export const SUBMISSION_SUCCESS_PARAGRAPHS = [
	"You'll soon receive an email with details to help you make an informed decision. Please check your promotions, social, and spam folders. If our email is there, mark it as not spam.",
]
